// Theme Definitions for Professional Portfolio Website
// Each theme contains all color and styling variables needed for the website

// Original theme based on current design (extracted from variables.js)
export const original = {
  primary: '#0a192f', // Navy - main background
  accent: '#e8f2ffff', // White-new - your modified primary accent color (not #64ffda)
  background: '#0a192f', // Navy - main background
  text: '#d6defaff', // Lightest-slate - your modified primary text color
  textSecondary: '#8892b0', // Slate - secondary text
  textTertiary: '#a8b2d1', // Light-slate - tertiary text
  textMuted: '#495670', // Dark-slate - muted text
  backgroundSecondary: '#112240', // Light-navy - secondary background
  backgroundTertiary: '#233554', // Lightest-navy - tertiary background
  backgroundAccent: '#020c1b', // Dark-navy - accent background
  accentSecondary: '#f57dff', // Pink - secondary accent
  accentTertiary: '#57cbff', // Blue - tertiary accent
  accentTint: 'rgba(232, 242, 255, 0.1)', // Accent tint (updated to match your white-new)
  border: '#233554', // Border color
  borderLight: '#495670', // Light border
  shadow: 'rgba(27, 25, 2, 0.7)', // Box shadow (updated to match your navy-shadow)
  link: '#e8f2ffff', // Link color (your modified white-new)
  linkHover: '#e6f1ff', // Link hover color
  focus: '#e6f1ff', // Focus color
  white: '#e6f1ff', // White
  pureWhite: '#fff', // Pure white
  black: 'rgb(15, 23, 42)', // Black
  success: '#e8f2ffff', // Updated to use your accent color
  warning: '#f57dff',
  error: '#ff6b6b',
  info: '#57cbff',
};

// Original Light Theme 1 - Pure Monochrome (Grays & Blacks Only)
export const originalLight1 = {
  primary: '#1a1a1a', // Deep charcoal - main/primary
  accent: '#404040', // Medium gray - accent (no color, pure monochrome)
  background: '#ffffff', // Pure white - clean main background
  text: '#1a1a1a', // Deep charcoal - primary text
  textSecondary: '#404040', // Medium gray - secondary text
  textTertiary: '#666666', // Light gray - tertiary text
  textMuted: '#999999', // Very light gray - muted text
  backgroundSecondary: '#fafafa', // Off-white - secondary background
  backgroundTertiary: '#f5f5f5', // Light gray background - tertiary background
  backgroundAccent: '#1a1a1a', // Deep charcoal - accent background areas
  accentSecondary: '#666666', // Light gray - secondary accent
  accentTertiary: '#808080', // Medium-light gray - tertiary accent
  accentTint: 'rgba(64, 64, 64, 0.1)', // Gray tint
  border: '#e0e0e0', // Light border
  borderLight: '#f0f0f0', // Very light border
  shadow: 'rgba(26, 26, 26, 0.1)', // Subtle charcoal shadow
  link: '#404040', // Medium gray links
  linkHover: '#1a1a1a', // Dark gray hover
  focus: '#404040', // Medium gray focus
  white: '#ffffff', // Pure white
  pureWhite: '#ffffff', // Pure white
  black: '#1a1a1a', // Deep charcoal as black
  success: '#666666', // Gray for success
  warning: '#808080', // Medium gray for warning
  error: '#404040', // Medium gray for error
  info: '#666666', // Gray for info
};

// Original Light Theme - Optimized Green Professional (Primary Light Theme)
export const originalLight = {
  primary: '#1a202c', // Deep charcoal - main/primary for excellent contrast
  accent: '#2d8659', // Refined professional green - optimized for elegance
  background: '#ffffff', // Pure white - clean main background
  text: '#1a202c', // Deep charcoal - primary text (perfect readability)
  textSecondary: '#374151', // Darker medium gray - secondary text (better contrast)
  textTertiary: '#6b7280', // Improved light gray - tertiary text
  textMuted: '#9ca3af', // Better contrast light gray - muted text
  backgroundSecondary: '#f3f4f6', // Darker gray - cards and secondary backgrounds (better contrast)
  backgroundTertiary: '#e5e7eb', // Noticeable gray background - papers and tertiary elements
  backgroundAccent: '#1a202c', // Deep charcoal - accent background areas
  accentSecondary: '#38a169', // Medium green - secondary accent
  accentTertiary: '#48bb78', // Lighter green - tertiary accent
  accentTint: 'rgba(45, 134, 89, 0.12)', // More visible green tint for better UI feedback
  border: '#cbd5e1', // Stronger border for card definition
  borderLight: '#d1d5db', // More visible light border
  shadow: 'rgba(26, 32, 44, 0.15)', // Stronger shadow for clear card separation
  link: '#2d8659', // Refined green links
  linkHover: '#1a5d40', // Darker green hover
  focus: '#2d8659', // Refined green focus
  white: '#ffffff', // Pure white
  pureWhite: '#ffffff', // Pure white
  black: '#1a202c', // Deep charcoal as black
  success: '#2d8659', // Refined green for success
  warning: '#e69500', // Optimized orange for warning
  error: '#e53e3e', // Refined red for error
  info: '#3182ce', // Professional blue for info
};

// Original Light Theme 3 - Warm Amber Accent (Sophisticated & Warm)
export const originalLight3 = {
  primary: '#1a202c', // Deep charcoal - main/primary
  accent: '#d97706', // Warm amber/orange - sophisticated and warm accent
  background: '#ffffff', // Pure white - clean main background
  text: '#1a202c', // Deep charcoal - primary text
  textSecondary: '#4a5568', // Medium gray - secondary text
  textTertiary: '#718096', // Light gray - tertiary text
  textMuted: '#a0aec0', // Very light gray - muted text
  backgroundSecondary: '#f7fafc', // Off-white - secondary background
  backgroundTertiary: '#edf2f7', // Light gray background - tertiary background
  backgroundAccent: '#1a202c', // Deep charcoal - accent background areas
  accentSecondary: '#ed8936', // Lighter orange - secondary accent
  accentTertiary: '#f6ad55', // Light orange - tertiary accent
  accentTint: 'rgba(217, 119, 6, 0.1)', // Amber tint
  border: '#e2e8f0', // Light border
  borderLight: '#f1f5f9', // Very light border
  shadow: 'rgba(26, 32, 44, 0.1)', // Subtle charcoal shadow
  link: '#d97706', // Amber links
  linkHover: '#b45309', // Darker amber hover
  focus: '#d97706', // Amber focus
  white: '#ffffff', // Pure white
  pureWhite: '#ffffff', // Pure white
  black: '#1a202c', // Deep charcoal as black
  success: '#38a169', // Green for success
  warning: '#ed8936', // Orange for warning
  error: '#f56565', // Red for error
  info: '#4299e1', // Blue for info
};

// Scholarly Professional Theme (Improved - removed yellowish tint, more professional)
export const scholarlyProfessional = {
  primary: '#1B365D', // Refined Navy Blue - main/background
  accent: '#4A90A4', // Professional Teal - accent (removed gold yellowish tint)
  background: '#F7F9FC', // Clean White-Blue - main background
  text: '#1B365D', // Refined Navy Blue - primary text
  textSecondary: '#2C5F7A', // Medium Blue - secondary text
  textTertiary: '#7BA7BC', // Light Blue-Gray - tertiary text
  textMuted: '#9BB5C7', // Muted Blue-Gray - muted text
  backgroundSecondary: '#F0F4F7', // Soft Background - secondary
  backgroundTertiary: '#E8F0F5', // Very Light Blue - tertiary
  backgroundAccent: '#1B365D', // Refined Navy Blue - accent background
  accentSecondary: '#2C5F7A', // Medium Blue - secondary accent
  accentTertiary: '#7BA7BC', // Light Blue-Gray - tertiary accent
  accentTint: 'rgba(74, 144, 164, 0.15)', // Professional Teal tint
  border: '#D1E0E8', // Light Blue Border
  borderLight: '#E8F0F5', // Very Light Blue border
  shadow: 'rgba(27, 54, 93, 0.12)', // Subtle Navy shadow
  link: '#4A90A4', // Professional Teal links
  linkHover: '#1B365D', // Navy blue hover
  focus: '#4A90A4', // Teal focus
  white: '#F7F9FC', // Clean background as white
  pureWhite: '#ffffff', // Pure white
  black: '#1B365D', // Navy as black
  success: '#4A90A4', // Teal for success
  warning: '#2C5F7A', // Medium blue for warning
  error: '#B85A5A', // Muted red for error
  info: '#7BA7BC', // Light blue for info
};

// Natural Scientist Theme (Earthy, academic, and calm)
export const naturalScientist = {
  primary: '#2D572C', // Dark Green - main/primary
  accent: '#344E41', // Deep Forest - accent
  background: '#FDFCDC', // Beige Background - main background
  text: '#2D572C', // Dark Green - primary text
  textSecondary: '#588157', // Forest Green - secondary text
  textTertiary: '#A3B18A', // Sage - tertiary text
  textMuted: '#A3B18A', // Sage - muted text
  backgroundSecondary: '#FDFCDC', // Beige - secondary background
  backgroundTertiary: '#A3B18A', // Sage - tertiary background
  backgroundAccent: '#2D572C', // Dark Green - accent background
  accentSecondary: '#588157', // Forest Green - secondary accent
  accentTertiary: '#A3B18A', // Sage - tertiary accent
  accentTint: 'rgba(52, 78, 65, 0.1)', // Forest tint
  border: '#A3B18A', // Sage border
  borderLight: '#FDFCDC', // Beige light border
  shadow: 'rgba(45, 87, 44, 0.2)', // Green shadow
  link: '#344E41', // Forest links
  linkHover: '#2D572C', // Dark green hover
  focus: '#344E41', // Forest focus
  white: '#FDFCDC', // Beige as white
  pureWhite: '#ffffff', // Pure white
  black: '#2D572C', // Dark green as black
  success: '#588157',
  warning: '#A3B18A',
  error: '#344E41',
  info: '#2D572C',
};

// Modern Innovator Theme (Sophisticated and contemporary)
export const modernInnovator = {
  primary: '#252627', // Charcoal - main/primary
  accent: '#00A6A6', // Muted Teal - accent
  background: '#F7F7FF', // Ghost White - main background
  text: '#252627', // Charcoal - primary text
  textSecondary: '#495867', // Slate Gray - secondary text
  textTertiary: '#577399', // Blue Gray - tertiary text
  textMuted: '#577399', // Blue Gray - muted text
  backgroundSecondary: '#F7F7FF', // Ghost White - secondary
  backgroundTertiary: '#577399', // Blue Gray - tertiary
  backgroundAccent: '#252627', // Charcoal - accent background
  accentSecondary: '#495867', // Slate Gray - secondary accent
  accentTertiary: '#577399', // Blue Gray - tertiary accent
  accentTint: 'rgba(0, 166, 166, 0.1)', // Teal tint
  border: '#577399', // Blue Gray border
  borderLight: '#F7F7FF', // Ghost White light border
  shadow: 'rgba(37, 38, 39, 0.2)', // Charcoal shadow
  link: '#00A6A6', // Teal links
  linkHover: '#252627', // Charcoal hover
  focus: '#00A6A6', // Teal focus
  white: '#F7F7FF', // Ghost White as white
  pureWhite: '#ffffff', // Pure white
  black: '#252627', // Charcoal as black
  success: '#00A6A6',
  warning: '#495867',
  error: '#577399',
  info: '#252627',
};

// Focused Minimalist Theme (Clean, structured, high-contrast)
export const focusedMinimalist = {
  primary: '#212529', // Near Black - main/primary
  accent: '#FF6700', // Vibrant Orange - accent
  background: '#F8F9FA', // Off-White - main background
  text: '#212529', // Near Black - primary text
  textSecondary: '#495057', // Medium Gray - secondary text
  textTertiary: '#ADB5BD', // Light Gray - tertiary text
  textMuted: '#ADB5BD', // Light Gray - muted text
  backgroundSecondary: '#F8F9FA', // Off-White - secondary
  backgroundTertiary: '#ADB5BD', // Light Gray - tertiary
  backgroundAccent: '#212529', // Near Black - accent background
  accentSecondary: '#495057', // Medium Gray - secondary accent
  accentTertiary: '#ADB5BD', // Light Gray - tertiary accent
  accentTint: 'rgba(255, 103, 0, 0.1)', // Orange tint
  border: '#ADB5BD', // Light Gray border
  borderLight: '#F8F9FA', // Off-White light border
  shadow: 'rgba(33, 37, 41, 0.2)', // Near Black shadow
  link: '#FF6700', // Orange links
  linkHover: '#212529', // Near Black hover
  focus: '#FF6700', // Orange focus
  white: '#F8F9FA', // Off-White as white
  pureWhite: '#ffffff', // Pure white
  black: '#212529', // Near Black as black
  success: '#FF6700',
  warning: '#495057',
  error: '#ADB5BD',
  info: '#212529',
};

// Elegant Academic Theme (Distinctive, refined, and thoughtful)
export const elegantAcademic = {
  primary: '#3D2B3D', // Dark Plum - main/primary
  accent: '#8C7A6B', // Muted Brown - accent
  background: '#F5F5F5', // Light Gray - main background
  text: '#3D2B3D', // Dark Plum - primary text
  textSecondary: '#5C4B5C', // Muted Plum - secondary text
  textTertiary: '#A499B3', // Heather - tertiary text
  textMuted: '#A499B3', // Heather - muted text
  backgroundSecondary: '#F5F5F5', // Light Gray - secondary
  backgroundTertiary: '#A499B3', // Heather - tertiary
  backgroundAccent: '#3D2B3D', // Dark Plum - accent background
  accentSecondary: '#5C4B5C', // Muted Plum - secondary accent
  accentTertiary: '#A499B3', // Heather - tertiary accent
  accentTint: 'rgba(140, 122, 107, 0.1)', // Brown tint
  border: '#A499B3', // Heather border
  borderLight: '#F5F5F5', // Light Gray light border
  shadow: 'rgba(61, 43, 61, 0.2)', // Plum shadow
  link: '#8C7A6B', // Brown links
  linkHover: '#3D2B3D', // Dark Plum hover
  focus: '#8C7A6B', // Brown focus
  white: '#F5F5F5', // Light Gray as white
  pureWhite: '#ffffff', // Pure white
  black: '#3D2B3D', // Dark Plum as black
  success: '#8C7A6B',
  warning: '#5C4B5C',
  error: '#A499B3',
  info: '#3D2B3D',
};

// Oceanic Calm Theme (Trustworthy, clean, and corporate)
export const oceanicCalm = {
  primary: '#003B46', // Deep Teal - main/primary
  accent: '#C4DFE6', // Very Light Blue - accent
  background: '#FFFFFF', // Pure White - main background
  text: '#003B46', // Deep Teal - primary text
  textSecondary: '#07575B', // Medium Teal - secondary text
  textTertiary: '#66A5AD', // Light Blue - tertiary text
  textMuted: '#66A5AD', // Light Blue - muted text
  backgroundSecondary: '#FFFFFF', // Pure White - secondary
  backgroundTertiary: '#C4DFE6', // Very Light Blue - tertiary
  backgroundAccent: '#003B46', // Deep Teal - accent background
  accentSecondary: '#07575B', // Medium Teal - secondary accent
  accentTertiary: '#66A5AD', // Light Blue - tertiary accent
  accentTint: 'rgba(196, 223, 230, 0.3)', // Light blue tint
  border: '#66A5AD', // Light Blue border
  borderLight: '#C4DFE6', // Very Light Blue light border
  shadow: 'rgba(0, 59, 70, 0.2)', // Deep Teal shadow
  link: '#07575B', // Medium Teal links
  linkHover: '#003B46', // Deep Teal hover
  focus: '#07575B', // Medium Teal focus
  white: '#FFFFFF', // Pure White
  pureWhite: '#ffffff', // Pure white
  black: '#003B46', // Deep Teal as black
  success: '#07575B',
  warning: '#66A5AD',
  error: '#C4DFE6',
  info: '#003B46',
};

// Sunset Vibrant Theme (Energetic, creative, and bold)
export const sunsetVibrant = {
  primary: '#6A2C70', // Dark Purple - background/primary
  accent: '#FFD166', // Bright Gold - accent
  background: '#6A2C70', // Dark Purple - main background (dark theme)
  text: '#F9ED69', // Yellow - primary text
  textSecondary: '#F08A5D', // Orange - secondary text
  textTertiary: '#FFD166', // Bright Gold - tertiary text
  textMuted: '#B83B5E', // Deep Magenta - muted text
  backgroundSecondary: '#B83B5E', // Deep Magenta - secondary background
  backgroundTertiary: '#F08A5D', // Orange - tertiary background
  backgroundAccent: '#6A2C70', // Dark Purple - accent background
  accentSecondary: '#F08A5D', // Orange - secondary accent
  accentTertiary: '#F9ED69', // Yellow - tertiary accent
  accentTint: 'rgba(255, 209, 102, 0.2)', // Gold tint
  border: '#B83B5E', // Deep Magenta border
  borderLight: '#F08A5D', // Orange light border
  shadow: 'rgba(106, 44, 112, 0.4)', // Purple shadow
  link: '#FFD166', // Gold links
  linkHover: '#F9ED69', // Yellow hover
  focus: '#FFD166', // Gold focus
  white: '#F9ED69', // Yellow as white
  pureWhite: '#ffffff', // Pure white
  black: '#6A2C70', // Dark Purple as black
  success: '#F9ED69',
  warning: '#F08A5D',
  error: '#B83B5E',
  info: '#FFD166',
};

// Material Dark Theme (Modern, high-contrast, tech-focused dark mode)
export const materialDark = {
  primary: '#121212', // True Black - background/primary
  accent: '#BB86FC', // Purple - accent
  background: '#121212', // True Black - main background
  text: '#E1E1E1', // Primary Text - primary text
  textSecondary: '#BB86FC', // Purple - secondary text (accent as secondary)
  textTertiary: '#03DAC6', // Teal Secondary - tertiary text
  textMuted: '#1E1E1E', // Dark Surface - muted text
  backgroundSecondary: '#1E1E1E', // Dark Surface - secondary background
  backgroundTertiary: '#BB86FC', // Purple - tertiary background
  backgroundAccent: '#121212', // True Black - accent background
  accentSecondary: '#03DAC6', // Teal Secondary - secondary accent
  accentTertiary: '#E1E1E1', // Primary Text - tertiary accent
  accentTint: 'rgba(187, 134, 252, 0.2)', // Purple tint
  border: '#1E1E1E', // Dark Surface border
  borderLight: '#BB86FC', // Purple light border
  shadow: 'rgba(18, 18, 18, 0.8)', // Black shadow
  link: '#BB86FC', // Purple links
  linkHover: '#03DAC6', // Teal hover
  focus: '#BB86FC', // Purple focus
  white: '#E1E1E1', // Primary Text as white
  pureWhite: '#ffffff', // Pure white
  black: '#121212', // True Black
  success: '#03DAC6',
  warning: '#BB86FC',
  error: '#E1E1E1',
  info: '#121212',
};

// Soft & Airy Theme (Light, gentle, and positive)
export const softAiry = {
  primary: '#FBF6F0', // Linen - background/primary
  accent: '#FFC0CB', // Pink - accent
  background: '#FBF6F0', // Linen - main background
  text: '#A7C7E7', // Light Blue - primary text
  textSecondary: '#B28DFF', // Lavender - secondary text
  textTertiary: '#F3E5AB', // Cream - tertiary text
  textMuted: '#FFC0CB', // Pink - muted text
  backgroundSecondary: '#A7C7E7', // Light Blue - secondary background
  backgroundTertiary: '#F3E5AB', // Cream - tertiary background
  backgroundAccent: '#FBF6F0', // Linen - accent background
  accentSecondary: '#B28DFF', // Lavender - secondary accent
  accentTertiary: '#A7C7E7', // Light Blue - tertiary accent
  accentTint: 'rgba(255, 192, 203, 0.3)', // Pink tint
  border: '#B28DFF', // Lavender border
  borderLight: '#F3E5AB', // Cream light border
  shadow: 'rgba(167, 199, 231, 0.3)', // Light blue shadow
  link: '#FFC0CB', // Pink links
  linkHover: '#B28DFF', // Lavender hover
  focus: '#FFC0CB', // Pink focus
  white: '#FBF6F0', // Linen as white
  pureWhite: '#ffffff', // Pure white
  black: '#A7C7E7', // Light Blue as black
  success: '#B28DFF',
  warning: '#F3E5AB',
  error: '#FFC0CB',
  info: '#A7C7E7',
};

// Earthy Terracotta Theme (Warm, organic, and stable)
export const earthyTerracotta = {
  primary: '#A8763E', // Dark Tan - main/primary
  accent: '#6D5D53', // Taupe - accent
  background: '#F4F3EE', // Eggshell - main background
  text: '#4A444B', // Charcoal - primary text
  textSecondary: '#A8763E', // Dark Tan - secondary text
  textTertiary: '#E0AFA0', // Terracotta - tertiary text
  textMuted: '#6D5D53', // Taupe - muted text
  backgroundSecondary: '#F4F3EE', // Eggshell - secondary background
  backgroundTertiary: '#E0AFA0', // Terracotta - tertiary background
  backgroundAccent: '#4A444B', // Charcoal - accent background
  accentSecondary: '#A8763E', // Dark Tan - secondary accent
  accentTertiary: '#E0AFA0', // Terracotta - tertiary accent
  accentTint: 'rgba(109, 93, 83, 0.2)', // Taupe tint
  border: '#E0AFA0', // Terracotta border
  borderLight: '#F4F3EE', // Eggshell light border
  shadow: 'rgba(74, 68, 75, 0.3)', // Charcoal shadow
  link: '#6D5D53', // Taupe links
  linkHover: '#A8763E', // Dark Tan hover
  focus: '#6D5D53', // Taupe focus
  white: '#F4F3EE', // Eggshell as white
  pureWhite: '#ffffff', // Pure white
  black: '#4A444B', // Charcoal as black
  success: '#A8763E',
  warning: '#E0AFA0',
  error: '#6D5D53',
  info: '#4A444B',
};

// Consolidated themes object containing all themes
export const themes = {
  original,
  originalLight,
  originalLight1,
  originalLight3,
  scholarlyProfessional,
  naturalScientist,
  modernInnovator,
  focusedMinimalist,
  elegantAcademic,
  oceanicCalm,
  sunsetVibrant,
  materialDark,
  softAiry,
  earthyTerracotta,
};

// Default theme - Change this to test different themes
export const defaultTheme = 'original'; // Try: 'originalLight', 'originalLight1', 'originalLight3', 'original', 'naturalScientist', 'modernInnovator', etc.

// Get theme by name
export const getTheme = (themeName = defaultTheme) => themes[themeName] || themes[defaultTheme];

// Get all theme names
export const getThemeNames = () => Object.keys(themes);

// Get themes by type (helper function for filtering)
export const getThemesByName = nameArray =>
  nameArray.reduce((acc, name) => {
    if (themes[name]) {
      acc[name] = themes[name];
    }
    return acc;
  }, {});

// Get light/dark themes (you can extend this with type property if needed)
// export const getDarkThemes = () => getThemesByName(['original', 'sunsetVibrant', 'materialDark']);
export const getLightThemes = () =>
  getThemesByName([
    'originalLight',
    'originalLight1',
    'originalLight3',
    'scholarlyProfessional',
    'naturalScientist',
    'modernInnovator',
    'focusedMinimalist',
    'elegantAcademic',
    'oceanicCalm',
    'softAiry',
    'earthyTerracotta',
  ]);
